import React from 'react'
import { Button, Image } from 'react-bootstrap'
import '../App.css'
import FirebaseStateComponent from './FirebaseStateComponent.js'

export default class User extends FirebaseStateComponent {
  constructor (props) {
    super(props)

    // Start with empty state
    this.state = {
      user: null
    }

    // Add user binding
    this.handleProps(props, false)
  }

  componentWillReceiveProps (nextProps) {
    // Process new props
    this.handleProps(nextProps)
  }

  handleProps (props, checkPrevious = true) {
    // Check if the new props contain the 'uid' value
    if (props.hasOwnProperty('uid') && props.uid !== null) {
      // Check if the value has changed
      if (!checkPrevious || !this.props.hasOwnProperty('uid') || this.props.uid !== props.uid) {
        this.addBinding('user', 'users/' + props.uid)
      }
    } else {
      // No new 'uid' value, remove user binding
      this.removeBinding('user')
    }
  }

  render () {
    // Create style object
    var style = {
      paddingBottom: (this.props.padding === true ? '10px' : '0px')
    }

    if (this.state.user === null) {
      return null
    } else {
      // Create image and name
      var imageUrl = (this.state.user.photoURL ? this.state.user.photoURL : (this.state.user.gender === 'female' ? 'female.jpg' : 'male.jpg'))
      var image = <Image circle src={imageUrl} style={{height: '50px', width: '50px', marginRight: '10px'}} alt={this.state.user.displayName} />
      var name = this.state.user.displayName

      // Create you-label if user is itself
      var label = null
      if (this.props.you === true) {
        label = ' (you)'
      } else if (this.props.friend === true) {
        label = ' (friend)'
      }

      // Create add button if callback is set and user is not itself or a friend
      var addButton = null
      if (this.props.friend !== true && this.props.hasOwnProperty('onAdd')) {
        addButton = <Button bsStyle='link' onClick={() => this.props.onAdd(this.state.user.uid)}>Add</Button>
      }

      // Create remove button if callback is set
      var removeButton = null
      if (this.props.hasOwnProperty('onRemove') && !this.state.user.hasOwnProperty('parentUid')) {
        removeButton = <Button bsStyle='link' onClick={() => this.props.onRemove(this.state.user.uid)}>Remove</Button>
      }

      return (
        <div className='User' style={style}>
          {image}
          {name}
          <i>{label}</i>
          {addButton}
          {removeButton}
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/User.js